export default {
	templates: null
}
